import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGolfBall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M14 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-2-4a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1" />
  </svg>
);
export default SvgGolfBall;
